<template>
  <b-card>
    <layout-loading v-if="isSubmit" />
    <b-form>
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('general.title')"
            label-for="video-title"
          >
            <b-form-input
              id="video-title"
              v-model="form.title"
              :state="validateState('title')"
            />
            <b-form-invalid
              id="input-title-feedback"
              :label="$t('general.title')"
              :validator="$v.form.title"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('general.status')"
            label-for="video-status"
            :state="validateState('status')"
          >
            <b-form-select v-model="form.status">
              <b-form-select-option
                v-for="(status, index) in statusOptions"
                :key="index"
                :value="status"
              >
                {{ $t(`articles.${status}`) }}
              </b-form-select-option>
            </b-form-select>
            <b-form-invalid
              id="input-status-feedback"
              :label="$t('general.status')"
              :validator="$v.form.status"
              :is-bootstrap="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>
<script>
import {
  BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BFormSelect, BFormSelectOption, BRow,
} from 'bootstrap-vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import '@/components/VSelectCustom/index.vue'
import { required, minLength } from 'vuelidate/lib/validators'
import LayoutLoading from '@/components/LayoutLoading.vue'
import useUnitList from './useUnitList'

export default {
  name: 'UnitAdd',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BFormSelect,
    BRow,
    BFormSelectOption,
    LayoutLoading,
  },
  validations() {
    return {
      form: {
        title: {
          required,
          minLength: minLength(3),
        },
        status: {
          required,
        },
      },
    }
  },
  setup() {
    const {
      addItem,
      form,
      isSubmit,
      statusOptions,
    } = useUnitList()
    return {
      addItem,
      form,
      isSubmit,
      statusOptions,
    }
  },
  methods: {
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      const data = {
        title: this.form.title,
        status: this.form.status,
      }
      this.addItem(data)
    },
    validateState(name) {
      const {
        $dirty,
        $error,
      } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    sendData(form) {
      const data = {
        title: form.title,
        status: form.status,
      }
      this.addItem(data)
    },
  },
}
</script>

  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss"
  </style>
